import type { Dealness } from "@b2bportal/air-shopping-api";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import clsx from "clsx";
import defaultStyles from "./PriceForecast.module.scss";

interface PriceForecastItem {
  dealness: Dealness;
  title: string;
}
export interface PriceForecastProps {
  items: PriceForecastItem[];
  dealness: Dealness;
}

export const PriceForecast = ({ items, dealness }: PriceForecastProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.PriceForecast;

  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={block}>
      {items.map((item) => (
        <div key={item.dealness} className={cn("item")}>
          <p
            className={clsx(cn("item-label"), {
              [cn("dealness")]: dealness === item.dealness,
            })}
          >
            {item.title}
            {dealness === item.dealness && (
              <div
                className={cn("dealness-indicator", [dealness.toLowerCase()])}
              ></div>
            )}
          </p>
        </div>
      ))}
    </div>
  );
};
